export const onLoad = () => {

	document.onreadystatechange = function () {

		if (document.readyState === 'interactive') {

			setTimeout(()=>{
				window.document.body.classList.add('loaded');
			}, 50);

		}

	}
};
